import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { getFavorites } from '@libs/api-proxy-client';
import { useUserSession } from '../../hooks/useUserSession';
import { useStore } from '../../providers/StoreProvider';
import { FAVORITES_QUERY_KEY } from './queryKey';
const SIX_HOURS = 6 * 3600000;
type UseFavoritesQueryProps = {
  storeId?: string | null;
};
export const useFavoritesQuery = t0 => {
  const $ = _c(12);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    storeId
  } = t1;
  const {
    user
  } = useUserSession();
  const {
    selectedStoreId
  } = useStore();
  const effectiveStoreId = storeId ?? selectedStoreId ?? null;
  let t2;
  if ($[2] !== user?.customerprofileid) {
    t2 = user?.customerprofileid?.toString();
    $[2] = user?.customerprofileid;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = [FAVORITES_QUERY_KEY, t2];
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== effectiveStoreId) {
    t4 = () => getFavorites({
      storeId: effectiveStoreId
    });
    $[6] = effectiveStoreId;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = Boolean(user?.customerprofileid);
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = {
      queryKey: t3,
      queryFn: t4,
      select: _temp,
      staleTime: SIX_HOURS,
      enabled: t5
    };
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return useQuery(t6);
};
function _temp(data) {
  return data && "items" in data ? data?.items : [];
}